module.exports = __webpack_public_path__ + "static/img/mobile_error.bd5782cc.png";